import { render, staticRenderFns } from "./ActivateVendor.vue?vue&type=template&id=34eaf0a2&"
import script from "./ActivateVendor.vue?vue&type=script&lang=js&"
export * from "./ActivateVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports